import { BodyZone, CreateBodyZone } from '@/generated';
import { bodyZoneApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('body-zone-refresh');

export const useCreateBodyZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createBodyZone: CreateBodyZone) => bodyZoneApi.bodyZoneCreate({ createBodyZone: createBodyZone }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.BodyZones] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateBodyZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (bodyZone: BodyZone) => bodyZoneApi.bodyZoneUpdate({ bodyZone: bodyZone }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.BodyZones] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeleteBodyZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (bodyZoneId: string) => bodyZoneApi.bodyZoneDelete({ bodyZoneId }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.BodyZones] });
      refreshChannel.postMessage('refresh');
    },
  });
};
